export default "__VITE_ASSET__939e8faa__"